import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { CircularProgress } from "@mui/material";
import { useRef } from "react";

type Props = {};

const ZoneMasterEdit = (props: Props) => {
  console.log("useLocation " + useLocation());
  const location = useLocation();
  console.log("location", location.state);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  let navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const [toaster, setToaster] = useState(false);
  const validationSchema = Yup.object({
    zoneName: Yup.string()
      .matches(/^[A-Za-z0-9\s]+$/, t("text.noSpecialChars")) // only letters, numbers, spaces
      .required(t("text.req")),
    zoneCode: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, t("text.noSpecialChars")) // only letters and numbers
      .required(t("text.req")),
  });

  const formik = useFormik({
    initialValues: {
      zoneID: location.state.id,
      zoneName: location.state.zoneName,
      zoneCode: location.state.zoneCode,
      sortOrder: 0,
      isActive: location.state.isActive,
      user_ID: 0,
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      // Clear any existing timeout
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }

      // If already submitting, show message and return
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }

      setIsSubmitting(true);

      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `Zone/AddUpdateZonemaster`,
          values
        );

        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate('/master/ZoneMaster');
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        // Set a timeout to reset isSubmitting after 2 seconds
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    },


  });
  // Add cleanup effect
  React.useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);
  const requiredFields = ['zoneName'];


  const back = useNavigate();
  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh"
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.editZoneMaster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item lg={6} xs={12}>
                <TextField
                  id="zoneName"
                  name="zoneName"
                  label={t("text.enterZoneName")}
                  value={formik.values.zoneName}
                  placeholder={t("text.enterZoneName")}
                  size="small"
                  fullWidth
                  onChange={(e) => {
                    // Remove anything that is NOT letters, numbers, or spaces
                    const value = e.target.value.replace(/[^A-Za-z0-9\s]/g, "");
                    formik.setFieldValue("zoneName", value);
                  }}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ maxLength: 30 }}
                />
                {formik.touched.zoneName && formik.errors.zoneName ? (
                  <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.zoneName)}</div>
                ) : null}
              </Grid>

              <Grid item lg={6} xs={12}>
                <TextField
                  id="zoneCode"
                  name="zoneCode"
                  label={t("text.enterZoneCode")}
                  value={formik.values.zoneCode}
                  placeholder={t("text.enterZoneCode")}
                  size="small"
                  fullWidth
                  onChange={(e) => {
                    // Remove anything that is NOT letters or numbers
                    const value = e.target.value.replace(/[^A-Za-z0-9]/g, "");
                    formik.setFieldValue("zoneCode", value);
                  }}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={isSubmitting}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.update")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={isSubmitting}
                  onClick={() => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
            {/* </Card> */}
          </form>

        </CardContent>
      </div>
    </div>
  );
};

export default ZoneMasterEdit;
